import { render, staticRenderFns } from "./sendingExType.vue?vue&type=template&id=07882605&"
import script from "./sendingExType.vue?vue&type=script&lang=js&"
export * from "./sendingExType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports